import { EAppActions } from "./types";
export const appReducer = (prevState, action) => {
    switch (action.type) {
        /* -------------------------------------------------------------------------------------------------
         * App
         * -----------------------------------------------------------------------------------------------*/
        case EAppActions.CONNECT_WALLET_OPEN:
            return {
                ...prevState,
                walletConnectOpen: action.payload.walletConnectOpen,
            };
        case EAppActions.SET_OFFCANVAS_OPEN:
            return {
                ...prevState,
                offCanvasOpen: action.payload.offCanvasOpen,
            };
        case EAppActions.SET_NETWORK_OPEN:
            return {
                ...prevState,
                networkOpen: action.payload.networkOpen,
            };
        case EAppActions.SET_ERROR_REPORTING_ENABLED:
            return {
                ...prevState,
                errorReportingEnabled: action.payload.errorReportingEnabled,
            };
        /* -------------------------------------------------------------------------------------------------
         * Exchange
         * -----------------------------------------------------------------------------------------------*/
        case EAppActions.SET_ASSET_SELECT_CONTEXT:
            return {
                ...prevState,
                exchange: {
                    ...prevState.exchange,
                    assetSelectContext: action.payload.assetSelectContext,
                },
            };
        case EAppActions.SET_ASSET_SELECT_OPEN:
            return {
                ...prevState,
                exchange: {
                    ...prevState.exchange,
                    assetSelectOpen: action.payload.assetSelectOpen,
                },
            };
        case EAppActions.SET_EXCHANGE_INPUT_VALUE:
            return {
                ...prevState,
                exchange: {
                    ...prevState.exchange,
                    inputValue: action.payload.inputValue,
                },
            };
        case EAppActions.SET_EXCHANGE_OUTPUT_VALUE:
            return {
                ...prevState,
                exchange: {
                    ...prevState.exchange,
                    outputValue: action.payload.outputValue,
                },
            };
        default:
            throw new Error("No action was found!");
    }
};
//# sourceMappingURL=reducer.js.map